import React from "react";
import AdminUserNav from "./Navs/AdminUserNav";
import ClientELearningNav from "./Navs/ClientElearningNav";
import LearnerNav from "./Navs/LearnerNav";
import SettingsNav from "./Navs/SettingsNav";
import TakeABreakNav from "./Navs/TakeABreakNav";

const ClientMenu = (props) => {
  return (
    <>
      <SettingsNav
        context={props.context}
        manipulateColours={props.manipulateColours}
      />
      <AdminUserNav
        context={props.context}
        manipulateColours={props.manipulateColours}
      />
      <LearnerNav
        context={props.context}
        manipulateColours={props.manipulateColours}
      />
      <ClientELearningNav
        context={props.context}
        manipulateColours={props.manipulateColours}
      />
      <TakeABreakNav context={props.context} />
    </>
  );
};

export default ClientMenu;
